export default __webpack_public_path__ + "static/media/5.bb7d9b2a.jpeg";